import i18next from "i18next";
import {rsoSmartLogin} from "../RsoAuthBackend";
import * as Util from "../Util";
import {showMessage} from "../../Setting";
import {getProtocolType} from "../../utils/AuthUtil";
import {useEmployee} from "../../providers/EmployeeContext";

export const useGoBack = ({
  formRef,
  application,
  serviceUrl,
  returnUrl,
  location,
  onFormConfigChange,
}) => {
  const {isEmployee, setIsEmployee} = useEmployee();

  const canGoBack = (formConfig) => {
    const noBackSteps = ["user_check", "initial"];
    return !noBackSteps.includes(formConfig.type) && formConfig.stateId;
  };

  const goBack = async(formConfig) => {
    if (!formConfig.stateId) {
      showMessage("error", i18next.t("general:Session state not found"));
      return;
    }

    try {
      const protocolType = getProtocolType(location, application);
      const oauthParams = Util.getOAuthGetParameters();

      const response = await rsoSmartLogin(
        {
          revisit_previous_step: true,
          is_employee: isEmployee,
        },
        {
          application: application.name,
          organization: application.organization,
        },
        formConfig.stateId,
        application.name,
        application.organization,
        protocolType,
        oauthParams,
        serviceUrl
      );

      if (response?.status !== "ok") {
        showMessage("error", response?.msg || i18next.t("general:Operation failed"));
        return;
      }

      const data = response.data;
      if (!data || data.status !== "ok") {
        showMessage("error", i18next.t("general:Invalid response from server"));
        return;
      }

      const {
        current_step,
        next_step_data_required,
        data_required,
        user_data,
        state_id,
        message,
        is_next_step_skippable,
        actions,
        // فرض می‌کنیم API یک فلگ برای تشخیص مرحله اول برمی‌گرداند
        is_initial_step,
      } = data;
      const serverIsEmployee = user_data?.is_employee !== undefined
        ? (user_data.is_employee === true || user_data.is_employee === "true")
        : isEmployee;

      setIsEmployee(serverIsEmployee);

      const previousStepConfig = {
        stepName: current_step,
        type: current_step,
        dataRequired: next_step_data_required || data_required || [],
        initialValues: {
          ...user_data,
          is_employee: serverIsEmployee,
        },
        stateId: state_id,
        isNextStepSkippable: is_next_step_skippable ?? false,
        errorMessage: message || null,
        actions: actions,
        isInitialStep: is_initial_step === true,
      };

      onFormConfigChange(previousStepConfig);

    } catch (e) {
      showMessage("error", e.message || i18next.t("general:Network error"));
    }
  };

  return {canGoBack, goBack};
};
